// extracted by mini-css-extract-plugin
module.exports = {"filtersSelected":"styles_filtersSelected__1owjN"};